module.exports = __webpack_public_path__ + "static/media/mobile-app.e9a248b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile-app.svg
// module id = 27
// module chunks = 0